import { AuctionSection } from '@/components/dashboard/AuctionSection'

// "Auction" — the daily pro-rata fundraising auction (deposit ETH/TITANX/X28 -> pro-rata share of the
// day's HORIZON, claimed next day). AuctionSection carries its own SectionHeader, so this is just the
// standard-width wrapper around it. Replaces the retired MintPage/MintSection (HORIZON-AUCTION-SPEC.md).
export function AuctionPage() {
  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '24px' }}>
      <AuctionSection />
    </div>
  )
}
